import { Component, ViewChild, AfterViewInit, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SocialComponent } from '../../controls/social/social.component';
import { TranslateService } from '@ngx-translate/core';
declare var $: any;

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html'
})
export class HomeComponent implements AfterViewInit, OnInit {
    @ViewChild(SocialComponent)
    public socialComponent: SocialComponent;
    private mobileMenuVisible: boolean = false;

    constructor(
        private router: Router,
        private translateService: TranslateService) {
        this.translateService.setTranslation('pt', { "User does not exist or password is incorrect.": 'Usuário não existe ou senha incorreta.' }, true);
        this.translateService.setTranslation('pt', { "The user is blocked due a 5 invalid login attempts.": 'O usuário está bloqueado devido a 5 tentativas inválidas de login.' }, true);
    }

    ngOnInit() {
        this.socialComponent.checkDarkMode();
    }

    ngAfterViewInit(): void {
    }

    mobileMenu() {
        if (this.mobileMenuVisible) {
            this.mobileMenuVisible = false;
        } else {
            this.mobileMenuVisible = true;
        }
        if (this.mobileMenuVisible) {
            $(".mobile-menu").removeClass('hide');
            $(".mobile-menu").fadeIn('slow');
            
            $(".actionable").addClass('card-icon-menu-actionable-active');
        } else {
            $(".mobile-menu").addClass('hide');
            
            $(".actionable").removeClass('card-icon-menu-actionable-active');
        }
    }

    scroll(el: HTMLElement) {
        el.scrollIntoView({ behavior: "smooth" });
    }


    goToLogin() {
        this.router.navigate(['/login']);
    }

    goToHome() {
        this.router.navigate(['/']);
    }
}